import styled from "styled-components/macro";
import { ThreeDots } from "@styled-icons/bootstrap";

export const HouseTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #464646;
`;
export const DropdownIcon = styled(ThreeDots)`
  cursor: pointer;
  width: 20px;
`;

export const RoomOverViewContainer = styled.div`
  width: 100%;
  border: 1px solid #dfe1eb;
  border-radius: 8px;
  overflow: hidden;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

export const WrapperContainer = styled.div`
  & > .header {
    margin-bottom: 16px;

    & > div {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      margin-left: auto;
      align-items: center;
      & > div {
        align-self: flex-start;
      }
    }
  }
  & .min-width {
    min-width: 60px;
  }

  & > .mainContent {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media ${(props) => props.theme.media.phone} {
      flex-direction: column;
    }

    & * > p {
      font-size: 1rem;
      line-height: 130%;
      margin: 0;
      color: ${(props) => props.theme.colors.text};

      &.title {
        font-weight: 600;
      }
    }
  }
`;

export const WrapperContainerNew = styled.div<{ isPublished?: boolean }>`
  display: flex;
  @media ${(props) => props.theme.media.phone} {
    flex-direction: column;
  }

  justify-content: space-between;
  align-items: center;
  min-height: 150px;
  background-color: ${(props) => (props.isPublished ? "#ffffff" : "#F8F8F8")};

  .block {
    padding: 0 20px;
  }

  .name-dropdown-wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;

    a {
      display: inline-block;
    }

    @media ${(props) => props.theme.media.phone} {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
  }

  .info-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-grow: 2;
    @media ${(props) => props.theme.media.phone} {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: start;
      margin: 1rem 0;
    }
  }

  .image-block {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    order: -1;

    a {
      display: inline-block;
      height: 86px;
      width: 111px;
      @media ${({ theme }) => theme.media.phone} {
        height: 228px;
        width: 325px;
      }
    }

    @media ${(props) => props.theme.media.phone} {
      order: 0;
    }
  }

  .publish-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media ${(props) => props.theme.media.phone} {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }
`;

export const TogglePublish = styled.div`
  height: 16px;
  width: 100%;
  background-color: #cdc2ba;
  position: relative;
  border-radius: 34px;
  cursor: pointer;
  transition: 0.4s;

  &:before {
    background-color: #fff;
    bottom: 2px;
    content: "";
    height: 12px;
    left: 2px;
    position: absolute;
    transition: 0.4s;
    width: 12px;
    border-radius: 50%;
  }
`;

export const PublishButton = styled.div<{ isRented?: boolean }>`
  @media ${(props) => props.theme.media.phone} {
    margin-top: 1rem;
    width: 100%;
  }

  width: 247px;
  padding: 1rem;

  @media ${(props) => props.theme.media.phone} {
    padding: 0.5rem;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: ${(props) => props.theme.font.size};

  .top-row {
    display: flex;
    @media ${(props) => props.theme.media.phone} {
      flex-direction: row;
      .publish-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        font-weight: 500;
      }
    }
    justify-content: space-between;
    align-items: center;
    width: 100%;

    gap: 1rem;

    .publish-group {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      & > a,
      & > label {
        height: 16px;
        width: 32px;
        @media ${(props) => props.theme.media.phone} {
          height: 25px;
          width: 50px;
        }
      }

      & > label {
        display: flex;
        position: relative;

        & > input {
          display: none;
        }
        & > button {
          display: none;
        }

        .slider {
          background-color: #cdc2ba;
          bottom: 0;
          cursor: pointer;
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          transition: 0.4s;
        }

        .slider:before {
          background-color: #fff;
          bottom: 2px;
          content: "";
          height: 12px;
          left: 2px;
          position: absolute;
          transition: 0.4s;
          width: 12px;
          @media ${(props) => props.theme.media.phone} {
            width: 18.75px;
            height: 18.75px;
            bottom: 3px;
          }
        }

        input:checked + .slider {
          background-color: ${(props) =>
            props.isRented
              ? props.theme.colors.place
              : props.theme.colors.primary};
        }

        input:checked + .slider:before {
          transform: translateX(16px);
          @media ${(props) => props.theme.media.phone} {
            transform: translateX(25px);
          }
        }

        .slider.round {
          border-radius: 34px;
        }

        .slider.round:before {
          border-radius: 50%;
        }
      }
    }
  }
  .dots {
  }

  .bottom-row {
    text-align: center;
  }
`;

export const GridDeleteRoom = styled.div`
  display: grid;
  width: 100%;
  gap: 16px;
  padding: 16px;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "titleDel titleDel"
    "textDel textDel"
    "butCancel butDel";
  & > .titleDel {
    grid-area: titleDel;
  }
  & > .textDel {
    grid-area: textDel;
  }
  & > .butCancel {
    grid-area: butCancel;
  }
  & > .butDel {
    grid-area: butDel;
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
    grid-template-areas:
      "titleDel"
      "textDel"
      "butCancel"
      "butDel";
  }
`;

export const AvailabilityHouse = styled.p`
  font-size: 14px;
`;

export const AvailabilityHouseText = styled.div`
  margin-top: 8px;
  color: #767676;
  font-size: 14px;
`;

export const HouseVisable = styled.div`
  color: #767676;
  font-size: 16px;
  align-self: flex-start;
  margin-top: 4px;
`;
